import './TwoWay.scss';
import React, { useState, useEffect,useContext,useRef } from 'react'
import Utilities from './../../../../services/commonservice/utilities';
import SMSMessages from './SMSMessages'
import SMSConversations from './SMSConversations'
import ModelessBox from "./../../../../components/templates/components/ModelessBox"
import NotificationService from "./../../../../services/api/notification.service";
import { store } from '../../../../context/StateProvider';
import APIResponse from '../../../templates/components/APIResponse';

const TwoWay = (props) => {
    const globalStateAndDispatch = useContext(store);
    const contextState = globalStateAndDispatch.state;
    const [messages, setMessages] = useState();
    const [patientId, setPatientId] = useState();
    const [conversations, setConversations] = useState();
    const [showConversations, setShowConversations] = useState(true);
    const [menuIcon, setMenuIcon] = useState(`icon angle right`);
    const [patientName, setPatientName] = useState('');
    const [filteredId, setFilteredId] = useState();
    const [filteredName, setFilteredName] = useState();
    const [isLoading, setIsLoading ] = useState(false);
    const [clearPatientName, setClearPatientName ] = useState();
    
    const [apiResponse, setApiResponse] = useState()
    // const [isLoadingConversations, setIsLoadingConversations ] = useState(false);
    const childRef = useRef();
    const patientIdRef = useRef();
    const onSendMessage = (message) => {
        let notificationTracking = { message: message,
            practiceLocationId: contextState.practiceLocationId }
        NotificationService.sendSMS(notificationTracking, patientId)
        .then((res) => {
            setApiResponse(res);
        })
        .catch((err) => {
            setApiResponse(err);
        });
    };

    useEffect(() => {
    // Define the handler once and store its reference
    const handlePatientAlert = (eventTrigger) => {
        const data = eventTrigger?.detail;
        getConversations();
        if (data?.patientId) {
        setTimeout(() => getMessagesForPatient(data.patientId, true), 1000);
        }
    };

    Utilities.on("patientAlert", handlePatientAlert);

    // Cleanup when the dialog unmounts
    return () => {
        Utilities.off("patientAlert", handlePatientAlert);
    };
    }, []); // runs only once per mount


    useEffect(() => {
        if (patientId){
            patientIdRef.current = patientId;
            getMessagesForPatient();
            childRef.current.onChange()
        }
    }, [patientId]);          

    const getMessagesForPatient = (_patientId, isBackground = false) => {
        const selectedPatientId = patientIdRef.current;
        const targetPatientId = String(_patientId || selectedPatientId);
        if (!targetPatientId || (isBackground && targetPatientId !== selectedPatientId)) {
            return;
        }
        let existingText = childRef?.current?.getText?.() || "";
        let reqObj = {
            PatientId: targetPatientId,
            NotificationMethod: 2,
            practiceLocationId: contextState.practiceLocationId
        };
        setIsLoading(true)
        NotificationService.communicationsLookup(reqObj)
            .then((res) => {
                setIsLoading(false)
                let newMessages = [];
                if (Array.isArray(res?.data?.data) && res.data.data.length > 0) {
                    newMessages = res.data.data.sort((a, b) => { return new Date(a.createdOn) - new Date(b.createdOn) });
                    setPatientName(res?.data?.data[0]?.fullName);
                }
                if (Array.isArray(res?.data) && res.data.length > 0) {
                    newMessages = res.data.sort((a, b) => { return new Date(a.createdOn) - new Date(b.createdOn) });
                    setPatientName(res?.data[0]?.fullName);
                }

                if (newMessages.length > 0) {
                    setMessages(newMessages);
                    // Restore input selected patient
                    childRef?.current?.setTextExternally?.(existingText);
                    NotificationService.clearPendingMessages(targetPatientId, { practiceLocationId: contextState.practiceLocationId }).catch(() => { });
                }
                else {
                    setMessages();
                    //added to fix HPT-13757
                    if (clearPatientName) {
                        setPatientName();
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false)
            });
    }    

    let isLoadingConversations = false;
    const getConversations = () => {
        if (isLoadingConversations) return;
        isLoadingConversations = true;
        setConversations()
        NotificationService.getConversations(filteredId,contextState.practiceLocationId)
            .then(res => {
                if (res) {
                    setConversations(res?.data)
                }
            })
            .catch(err => {
                console.log(err);
            })
            .finally(()=>{                
                isLoadingConversations = false;
            })
    }

    const onSelectPatient = (newPatientId) => {
        setPatientId(newPatientId);
    }

    const onFilterPatient = (patient) => {
        if (patient?.id) {
            setFilteredId(patient.id);
            setFilteredName(patient.firstName + ' ' + patient.lastName);
        }
        else
        {
            setFilteredId();
            setFilteredName();
        }
    }

    useEffect(() => {
        getConversations();
    }, [filteredId]);         

    const startNewConversation = () => {
        setPatientId(filteredId);
        setPatientName(filteredName);
    }

    const onToggleConversations = () => {
        if (showConversations) {
            setMenuIcon(`icon angle left`);
        }
        else {
            setMenuIcon(`icon angle right`);
        }
        setShowConversations(!showConversations);
    }

    return ( 
        <div>
            <ModelessBox open={true} onClose={props.onClose} menuIcon={menuIcon} title={'Messages'} onMenuClick={onToggleConversations} >
                <div className="two-way">
                    {showConversations ? 
                        <SMSConversations conversations={conversations} setClearPatientName={setClearPatientName} startNewConversation={startNewConversation} onFilterPatient={onFilterPatient} filteredId={filteredId} onSelectPatient={onSelectPatient} patientId={patientId} />
                    :null}
                    <SMSMessages ref={childRef} setIsLoading={setIsLoading} isLoading={isLoading} patientName={patientName} patientId={patientId} messages={messages} onSendMessage={onSendMessage} />
                    <APIResponse apiResponse={apiResponse} toastOnFailure={true}/>
                </div>
            </ModelessBox>
        </div>
    )
}

export default TwoWay